import { gql } from 'graphql.macro';

export const vismaTokenLoginTemplate = gql`
    mutation vismaTokenLogin($authCode: String!) {
        vismaTokenLogin(authCode: $authCode)
    }
`;
